exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*base-link-mixin*/\n.dropdown-ota-style {\n  line-height: 19px;\n  padding: 10px 25px 10px 10px;\n  height: 40px;\n  cursor: pointer; }\n  .dropdown-ota-style.error {\n    border: 1px solid #ed1c24; }\n\n.fleet-card-item {\n  position: relative;\n  padding: 10px 10px 10px 35px;\n  width: 530px;\n  height: 50px;\n  background-color: white;\n  cursor: pointer; }\n  @media screen and (max-width: 767px) {\n    .fleet-card-item {\n      width: auto; } }\n  .fleet-card-item:hover {\n    background-color: #e4edff; }\n  .fleet-card-item .icon-fleet {\n    position: absolute;\n    left: 10px;\n    top: 10px;\n    font-size: 16px; }\n  .fleet-card-item .fleet-card-info {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between; }\n  .fleet-card-item .fleet-card-no,\n  .fleet-card-item .balance {\n    color: #061021;\n    font-size: 14px;\n    line-height: 16px; }\n  .fleet-card-item .fleet-card-type {\n    color: #6b778c;\n    font-size: 12px;\n    line-height: 14px; }\n\n.scorllable-box {\n  margin-top: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/fleet-card-select-box/fleet-card-select-box.component.scss
// module id = 892
// module chunks = 22